import {HttpClient} from '@esgi/api';
import {IEPGoalRequest, IEPGoalResponse} from './types';

export const getIEPGoal = (params: IEPGoalRequest) =>
	HttpClient.default.ESGIApi.get<IEPGoalResponse>(
		'assessments/test-session-results',
		'iep-goal',
		params,
	);
